// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const selectAllStatuses = statuses => ({
    statuses,
    type: actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES
});

export const selectStatus = (status, isSelected) =>

    dispatch => {

        dispatch({
            isSelected,
            status,
            type: actions.SELECT_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUS
        });

    };

export const selectStatusesOnLoad = statuses =>

    dispatch => {

        const approvedStatus = statuses.find(status => status.key === '3');
        const deletedStatus = statuses.find(status => status.key === '5');
        const reconciledStatus = statuses.find(status => status.key === '13');

        dispatch({
            statuses,
            type: actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES_ON_LOAD
        });

        if (approvedStatus) {

            selectStatus(approvedStatus, false)(dispatch);

        }

        if (deletedStatus) {

            selectStatus(deletedStatus, false)(dispatch);

        }

        if (reconciledStatus) {

            selectStatus(reconciledStatus, false)(dispatch);

        }

    };



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/status-selection.js